import React, {Component, Fragment} from 'react';
import {withTranslation} from "react-i18next";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import {route} from "../../../routes";
import {Content, GelContentContainer, GelContentRow, Link, FormBack, ScaleCard, StatCard, Utility, Sanitize} from 'cw-styleguide-react';
import SecondaryAutocompleteSearch from "../../../components/SecondaryAutocompleteSearch";
import Helmet from 'react-helmet';

class JobPayView extends Component {
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{this.props.data.name} - {this.props.t('route_pay_title')} | {this.props.t('route_app_title')}</title>
        </Helmet>

        <BreadcrumbsItem to={route('job', {job: this.props.data.slug}) + '/' + route('jobPay')}>
          {this.props.t('route_pay_title')}
        </BreadcrumbsItem>

        <GelContentContainer>
          <h1>{this.props.t('route_pay_title')}</h1>
          <h2 id={Utility.slug(this.props.t('pay_title'))}>
            {this.props.t('pay_title')}
          </h2>
          <GelContentRow>

            {/* Pay */}

            <ScaleCard
              from={this.props.data.pay.variesFlag ? this.props.t('styleguide:pay_varies') : (this.props.data.pay.starting ? "£" + this.props.data.pay.starting.toLocaleString()  : "")}
              to={this.props.data.pay.variesFlag ? this.props.t('styleguide:pay_varies') : (this.props.data.pay.experienced ? "£" + this.props.data.pay.experienced.toLocaleString() + (this.props.data.pay.moreFlag ? "+" : "" ) : "")}
              start={this.props.t('styleguide:pay_starting')}
              end={this.props.t('styleguide:pay_experienced')}
            />


          </GelContentRow>

          <Sanitize html={this.props.data.pay.rates} tag={"div"} classes={['style--list-circle','style--list-no-bg']} />

          <h2 id={Utility.slug(this.props.t('hours_of_work_title'))}>{this.props.t('hours_of_work_title')}</h2>

          <GelContentRow>

            {/* Hours */}

            <StatCard
              width={100}
              link={false}
              colour={'brand-f'}
              rows={
                [
                  {
                    icon: 'clock',
                    text: (this.props.data.hours.hoursIrregular && this.props.data.hours.hoursIrregular == "Yes" ?  <p>{this.props.t('typical_hours_irregular')}</p> :   <p><span>{this.props.data.hours.hours}</span> {this.props.t('typical_hours_counter')}</p>)
                  },
                  {
                    icon: this.props.data.hours.shiftPatterns && this.props.data.hours.shiftPatterns.length ? 'calendar' : '',
                    text: this.props.data.hours.shiftPatterns &&  this.props.data.hours.shiftPatterns.map((shift) => {
                      return <p>{shift}</p>
                    })
                  }
                ]
              }
            />


          </GelContentRow>
          <Sanitize html={this.props.data.hours.typicalHours}/>



          <hr/>
          <h2 id={Utility.slug(this.props.t('more_information_title'))}>
            {this.props.t('more_information_title')}
          </h2>
          <ul className="style style--list-large">
            <li>
              <Link to={route('job', {job: this.props.data.slug}) + '/' + route('jobRole')}>
                {this.props.t('route_role_title')}
              </Link>
            </li>
            <li>
              <Link to={route('job', {job: this.props.data.slug}) + '/' + route('jobBecome')}>
                {this.props.t('route_become_title')}
              </Link>
            </li>
            <li>
              <Link to={route('job', {job: this.props.data.slug}) + '/' + route('jobSkills')}>
                {this.props.t('route_skills_title')}
              </Link>
            </li>
          </ul>
          <FormBack url={route('job', {job: this.props.data.slug})} title={this.props.data.name}/>
          <hr className="thick"/>

          <SecondaryAutocompleteSearch  jobs={this.props.jobs}/>

        </GelContentContainer>
      </Fragment>
    )
  }
}

export default withTranslation('local')(JobPayView);
